export const BOATTRADER = 'boattrader';
export const BOATSDOTCOM = 'boatsdotcom';
export const YACHTWORLD = 'yachtworld';
